// B-1913 · LA FECHA, CON MAYÚSCULA SOLO EN LA PRIMERA LETRA.
//
// `textTransform: 'capitalize'` pone en mayúscula la primera letra de CADA palabra: «viernes, 25 de septiembre» salía
// «Viernes, 25 De Septiembre». En español solo va la primera: «Viernes, 25 de septiembre». Esto la pone y deja el resto
// como viene (los nombres de los meses y de los días, en minúscula, como los da toLocaleDateString('es-ES')).
export function primeraMayuscula(texto) {
  const s = texto == null ? '' : String(texto)
  return s ? s.charAt(0).toLocaleUpperCase('es-ES') + s.slice(1) : s
}
